import Button, { buttonVariants, ButtonProps } from "./Button";

export { Button, buttonVariants };
export type { ButtonProps };
